"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * A Typescript workaround of Object.keys, see
 * [YouTube explanation](https://www.youtube.com/watch?v=GW00zebIt0g)
 */
var objectKeys = function objectKeys(obj) {
  return Object.keys(obj);
};

var _default = objectKeys;
exports.default = _default;